import angular from 'angular';

class UserAccessService {
    constructor($q, $state, accountApiService, accountProvider, asLoadingMask, permissionService, stateConstants, sessionService, sessionTypeConstants) {
        this.$q = $q;
        this.$state = $state;
        this.accountApiService = accountApiService;
        this.accountProvider = accountProvider;
        this.asLoadingMask = asLoadingMask;
        this.permissionService = permissionService;
        this.stateConstants = stateConstants;
        this.sessionService = sessionService;
        this.sessionTypeConstants = sessionTypeConstants;

        this.promiseCache = {};
    }

    getUserAccess() {
        var promiseId = 'getUserAccess';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        var accountGuidAndUserGuidPromises = [this.accountProvider.getAccountGuid(), this.accountProvider.getUserGuid()];

        this.$q
            .all(accountGuidAndUserGuidPromises)
            .then(guidResults => {
                let accountGuid = guidResults[0];
                let userGuid = guidResults[1];

                let dataPromises = [
                    this.accountApiService.getSubscriptionEntitlement(accountGuid),
                    this.accountProvider.getAccountPlan(),
                    this.accountProvider.isAccountOwner(),
                    this.permissionService.getPermissionsOfUser(userGuid, 'support'),
                    this.permissionService.getPermissionsOfUser(userGuid, 'supportmanagement')
                ];

                this.$q.all(dataPromises).then(dataResults => {
                    let entitlement = dataResults[0];
                    let planInfo = dataResults[1];
                    let isAccountOwner = dataResults[2];
                    let hasSupportPermissions = !dataResults[3].notFound || !dataResults[4].notFound;

                    if (!isAccountOwner && !hasSupportPermissions) {
                        deferred.reject({
                            unauthorized: true
                        });

                        return;
                    }

                    let licenseAccess = this.constructLicenseAccess(entitlement, planInfo, isAccountOwner);
                    let supportAccess = this.constructSupportAccess(planInfo, isAccountOwner, hasSupportPermissions);
                    let settingsAccess = this.constructSettingsAccess(planInfo, isAccountOwner);
                    let billingAccess = this.constructBillingAccess(isAccountOwner);
                    let cloudRegistrationAccess = this.constructCloudAccess(isAccountOwner);
                    let userProvisionAccess = this.constructUserProvisionAccess(isAccountOwner);

                    deferred.resolve([...licenseAccess, ...supportAccess, ...settingsAccess, ...billingAccess, ...cloudRegistrationAccess, ...userProvisionAccess]);
                }, deferred.reject);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getGuestUserAccess() {
        return [this.stateConstants.billing.overview.name];
    }

    constructLicenseAccess(entitlement, planInfo, isAccountOwner) {
        if (!isAccountOwner) {
            return [];
        }

        let access = [this.stateConstants.license.overview.name];

        var perpetual = entitlement.ids.perpetual;
        var hasPerpetual = perpetual.deviceIds > 0 || perpetual.premiumIds > 0;
        var planStatus = planInfo.status ? planInfo.status.toLowerCase() : planInfo.status;

        if (!hasPerpetual && (planStatus == 'restricted' || planStatus == 'inactive')) {
            return access;
        }

        access.push(this.stateConstants.license.manage.name);
        return access;
    }

    constructSupportAccess(planInfo, isAccountOwner, hasSupportPermissions) {
        let endDate = new Date(planInfo.endDate);
        let hasSupportAttributeInPlan =
            (endDate > new Date() || endDate <= new Date(null)) && (planInfo.metadata.supportTypeOnline == 'true' || planInfo.metadata.supportTypePhone == 'true');

        if (hasSupportAttributeInPlan && (isAccountOwner || hasSupportPermissions)) {
            return [this.stateConstants.support.overview.name, this.stateConstants.support.createcase.name, this.stateConstants.support.viewcase.name];
        }

        return [];
    }

    constructSettingsAccess(planInfo, isAccountOwner) {
        if (planInfo && planInfo.metadata && isAccountOwner) {
            var access = [];

            if (planInfo.metadata.cloudPermission == 'true' && planInfo.metadata.cloudPermissionAccountportal == 'true') {
                access.push(this.stateConstants.settings.permission.name);
            }

            if (planInfo.metadata.featureSso == undefined || planInfo.metadata.featureSso == 'true') {
                access.push(this.stateConstants.settings.accountAuthentication.name);
            }

            if (access.length > 0) {
                access.unshift(this.stateConstants.settings.name);
            }

            return access;
        }

        return [];
    }

    constructBillingAccess(isAccountOwner) {
        if (isAccountOwner) {
            return [this.stateConstants.billing.overview.name];
        }

        return [];
    }

    constructCloudAccess(isAccountOwner) {
        if (isAccountOwner) {
            return [this.stateConstants.cloud.registration.name, this.stateConstants.cloud.urlVerification.name];
        }

        return [];
    }

    constructUserProvisionAccess(isAccountOwner) {
        if (isAccountOwner) {
            return [this.stateConstants.settings.userProvisioning.name];
        }

        return [];
    }

    hasAccessTo(stateName) {
        var deferred = this.$q.defer();

        if (this.sessionService.getSessionType() == this.sessionTypeConstants.guest) {
            var access = this.getGuestUserAccess();

            deferred.resolve(access.indexOf(stateName) >= 0);
        }

        this.getUserAccess().then(access => deferred.resolve(access.indexOf(stateName) >= 0), () => deferred.reject());

        return deferred.promise;
    }
}

angular.module('shared').service('userAccessService', UserAccessService);



// WEBPACK FOOTER //
// ./modules/shared/services/userAccess/userAccess.service.js